var map = {
	"./common/bg_check_blue.png": 55528,
	"./common/bg_check_white.png": 34692,
	"./common/bg_check_yellow.png": 6190,
	"./common/bg_form.png": 31191,
	"./common/bg_form_title.png": 79695,
	"./common/bg_form_title_sp.png": 4134,
	"./common/bg_line_blue.svg": 63898,
	"./common/bg_triangle_blue.png": 62324,
	"./common/bg_triangle_blue02.png": 61570,
	"./common/ico_angle_black.svg": 47701,
	"./common/ico_angle_blue.svg": 96026,
	"./common/ico_angle_down_black.svg": 57361,
	"./common/ico_angle_down_blue.svg": 26507,
	"./common/ico_angle_down_white.svg": 8300,
	"./common/ico_angle_white.svg": 82202,
	"./common/ico_arrow_blue.svg": 37731,
	"./common/ico_arrow_gray.svg": 96953,
	"./common/ico_arrow_right_white.svg": 51214,
	"./common/ico_arrow_white.svg": 76392,
	"./common/ico_back_blue.svg": 80221,
	"./common/ico_cartridge.svg": 77790,
	"./common/ico_check_blue.svg": 72551,
	"./common/ico_check_white.svg": 40059,
	"./common/ico_close_white.svg": 6615,
	"./common/ico_controller.svg": 82421,
	"./common/ico_elections.svg": 15487,
	"./common/ico_elections_white.svg": 13426,
	"./common/ico_external_black.svg": 4164,
	"./common/ico_external_blue.svg": 11393,
	"./common/ico_external_white.svg": 564,
	"./common/ico_full-screen_off.svg": 67016,
	"./common/ico_full-screen_on.svg": 46768,
	"./common/ico_help.svg": 55083,
	"./common/ico_lock_yellow.svg": 19292,
	"./common/ico_mag_blue.svg": 78699,
	"./common/ico_manual.svg": 30258,
	"./common/ico_menu_close.svg": 87270,
	"./common/ico_menu_open.svg": 74494,
	"./common/ico_new.svg": 33888,
	"./common/ico_new_mini.svg": 3175,
	"./common/ico_new_tag_red.svg": 78988,
	"./common/ico_new_yellow.svg": 22438,
	"./common/ico_pin_balloon_blue.svg": 981,
	"./common/ico_pin_balloon_red.svg": 40176,
	"./common/ico_pin_blue.svg": 67887,
	"./common/ico_search.svg": 22270,
	"./common/ico_share_black.svg": 79760,
	"./common/ico_share_blue.svg": 78789,
	"./common/ico_share_white.svg": 27761,
	"./common/ico_sound_off.svg": 4651,
	"./common/ico_sound_on.svg": 32560,
	"./common/ico_triangle_black.svg": 43590,
	"./common/img_device_landscape.png": 48312,
	"./common/img_yellow_deco.png": 24154,
	"./common/logo.png": 74225,
	"./common/logo_corporate.png": 68664,
	"./common/logo_facebook.svg": 8258,
	"./common/logo_header.svg": 9898,
	"./common/logo_line.svg": 26821,
	"./common/logo_twitter.svg": 75201,
	"./common/logo_twitter02.svg": 90622,
	"./common/logo_url.svg": 95622,
	"./common/logo_url_white.svg": 26904,
	"./common/logo_weibo.svg": 39704,
	"./common/text_off_white.svg": 31020,
	"./common/text_on_white.svg": 7451,
	"./common/text_playgame.svg": 3995,
	"./common/title_modal.svg": 84896,
	"./cookie_policy/txt_cookie_policy.svg": 98611,
	"./corporate/txt_operator.svg": 74055,
	"./elections/bg_vote_box.svg": 24971,
	"./elections/ico_check.svg": 42668,
	"./elections/pasts/ogp.png": 63499,
	"./elections/txt_capcoms_selection.svg": 64,
	"./elections/txt_past_selection.svg": 48390,
	"./elections/txt_share.svg": 88127,
	"./goods_factories/bg_footer.jpg": 58466,
	"./goods_factories/bg_footer01_sp.jpg": 67182,
	"./goods_factories/bg_footer02_sp.jpg": 30014,
	"./goods_factories/detail/bg_bubble.svg": 18479,
	"./goods_factories/detail/bg_detail.png": 89034,
	"./goods_factories/detail/bg_process01.svg": 47246,
	"./goods_factories/detail/bg_process01_sp.svg": 2569,
	"./goods_factories/detail/bg_process02.svg": 10618,
	"./goods_factories/detail/bg_process02_sp.svg": 26977,
	"./goods_factories/detail/img_badges01.png": 6159,
	"./goods_factories/detail/img_catalog01.png": 32987,
	"./goods_factories/detail/img_clip.svg": 86502,
	"./goods_factories/detail/img_deco01.svg": 54261,
	"./goods_factories/detail/img_deco01_sp.svg": 72805,
	"./goods_factories/detail/img_deco02.svg": 24469,
	"./goods_factories/detail/img_detail_process_hanafuda.png": 41320,
	"./goods_factories/detail/img_hanafuda01.png": 43998,
	"./goods_factories/detail/img_hanafuda02.png": 67664,
	"./goods_factories/detail/img_hanafuda03.png": 33479,
	"./goods_factories/detail/img_hanafuda04.png": 67262,
	"./goods_factories/detail/img_hanafuda05.png": 99948,
	"./goods_factories/goods_factories_ogp_de.png": 36226,
	"./goods_factories/goods_factories_ogp_en.png": 99295,
	"./goods_factories/goods_factories_ogp_es.png": 27717,
	"./goods_factories/goods_factories_ogp_fr.png": 52190,
	"./goods_factories/goods_factories_ogp_it.png": 97951,
	"./goods_factories/goods_factories_ogp_ja.png": 18713,
	"./goods_factories/goods_factories_ogp_ko.png": 52974,
	"./goods_factories/goods_factories_ogp_pt-BR.png": 96362,
	"./goods_factories/goods_factories_ogp_zh-CN.png": 42790,
	"./goods_factories/goods_factories_ogp_zh-TW.png": 45664,
	"./goods_factories/ico_angle_circle_blue.svg": 30427,
	"./goods_factories/ico_angle_circle_white.svg": 70882,
	"./goods_factories/ico_badges.svg": 43377,
	"./goods_factories/ico_catalog.svg": 68958,
	"./goods_factories/ico_free.svg": 6551,
	"./goods_factories/ico_gift.svg": 59922,
	"./goods_factories/ico_hanafuda.svg": 71541,
	"./goods_factories/img_footer_badges.png": 94773,
	"./goods_factories/img_footer_catalog.png": 55960,
	"./goods_factories/img_footer_hanafuda.png": 78061,
	"./goods_factories/img_gear_left.png": 97954,
	"./goods_factories/img_gear_left_sp.png": 28600,
	"./goods_factories/img_gear_right.png": 99722,
	"./goods_factories/img_gear_right_sp.png": 30302,
	"./goods_factories/img_kobun.png": 86870,
	"./goods_factories/img_truck.svg": 64779,
	"./goods_factories/souvenir/souvenir_ogp_de.png": 95132,
	"./goods_factories/souvenir/souvenir_ogp_en.png": 67603,
	"./goods_factories/souvenir/souvenir_ogp_es.png": 8176,
	"./goods_factories/souvenir/souvenir_ogp_fr.png": 54008,
	"./goods_factories/souvenir/souvenir_ogp_it.png": 45641,
	"./goods_factories/souvenir/souvenir_ogp_ja.png": 82566,
	"./goods_factories/souvenir/souvenir_ogp_ko.png": 12832,
	"./goods_factories/souvenir/souvenir_ogp_pt-BR.png": 64301,
	"./goods_factories/souvenir/souvenir_ogp_zh-CN.png": 22905,
	"./goods_factories/souvenir/souvenir_ogp_zh-TW.png": 97146,
	"./goods_factories/top/bg_hero.jpg": 47727,
	"./goods_factories/top/bg_hero_sp.jpg": 96208,
	"./goods_factories/top/bg_section01_sp.png": 16095,
	"./goods_factories/top/bg_section02_sp.png": 10327,
	"./goods_factories/top/bg_section03_sp.png": 51871,
	"./goods_factories/top/bg_slider.png": 8355,
	"./goods_factories/top/bg_slider.svg": 44804,
	"./goods_factories/top/bg_top.png": 6442,
	"./goods_factories/top/ico_screw.svg": 2234,
	"./goods_factories/top/img_badges.png": 72849,
	"./goods_factories/top/img_badges_sp.png": 66926,
	"./goods_factories/top/img_catalog.png": 66004,
	"./goods_factories/top/img_catalog_sp.png": 8311,
	"./goods_factories/top/img_hanafuda.png": 5704,
	"./goods_factories/top/img_hanafuda_sp.png": 83610,
	"./goods_factories/top/img_slider_badges.png": 46568,
	"./goods_factories/top/img_slider_catalog.png": 10550,
	"./goods_factories/top/img_slider_hanafuda.png": 26738,
	"./goods_factories/top/txt_badges.svg": 31657,
	"./goods_factories/top/txt_catalog.svg": 17710,
	"./goods_factories/top/txt_gift.svg": 39936,
	"./goods_factories/top/txt_hanafuda.svg": 94685,
	"./goods_factories/txt_goods_factory.svg": 39196,
	"./goods_factories/txt_goods_factory_sp.svg": 99402,
	"./goods_factories/txt_souvenir.svg": 14619,
	"./help/txt_a.svg": 60703,
	"./help/txt_capcom_elections.svg": 55951,
	"./help/txt_capcom_town.svg": 16057,
	"./help/txt_capcoms_selection.svg": 82338,
	"./help/txt_faq.svg": 28127,
	"./help/txt_latest_news.svg": 97962,
	"./help/txt_museum.svg": 85962,
	"./help/txt_other.svg": 73324,
	"./help/txt_q.svg": 68905,
	"./help/txt_retro_games.svg": 16029,
	"./help/txt_the_ceos_room.svg": 39365,
	"./help/txt_the_coos_room.svg": 99868,
	"./inquiries/txt_contact.svg": 67875,
	"./museums/aceattorney/guide.png": 94154,
	"./museums/bg_exhibit_ceiling.png": 26122,
	"./museums/bg_exhibit_dot.png": 49486,
	"./museums/bg_exhibit_light.png": 70310,
	"./museums/bg_exhibit_light_sp.png": 79170,
	"./museums/bg_exhibit_wall.png": 64342,
	"./museums/bg_flame01.png": 20771,
	"./museums/bg_flame02.png": 43059,
	"./museums/bg_flame03.png": 46565,
	"./museums/bg_flame_movie.png": 66973,
	"./museums/bg_shadow_sp.png": 55271,
	"./museums/dmc/guide.png": 4366,
	"./museums/ghostsngoblins/guide.png": 40139,
	"./museums/history/banner_esrb.jpg": 73369,
	"./museums/history/bg_film.svg": 25085,
	"./museums/history/bg_history.png": 64158,
	"./museums/history/bg_hot_page.png": 19697,
	"./museums/history/bg_hot_ripped.png": 9176,
	"./museums/history/bg_photo_frame.png": 82491,
	"./museums/history/character_dd.png": 27785,
	"./museums/history/character_dmc.png": 24475,
	"./museums/history/character_mh_2004.png": 37926,
	"./museums/history/character_mh_2018.png": 19237,
	"./museums/history/character_sf2.png": 93695,
	"./museums/history/history1985.jpg": 47592,
	"./museums/history/history1987.jpg": 58752,
	"./museums/history/history1989.jpg": 29340,
	"./museums/history/history1991.jpg": 21541,
	"./museums/history/history1993.jpg": 82860,
	"./museums/history/history1994.jpg": 60569,
	"./museums/history/history1994_02.jpg": 69019,
	"./museums/history/history1996.jpg": 30269,
	"./museums/history/history1997.jpg": 70178,
	"./museums/history/history2001.jpg": 97037,
	"./museums/history/history2001_02.jpg": 87621,
	"./museums/history/history2001_03.jpg": 6910,
	"./museums/history/history2002.jpg": 67719,
	"./museums/history/history2004.jpg": 55508,
	"./museums/history/history2005.jpg": 73510,
	"./museums/history/history2005_02.jpg": 43668,
	"./museums/history/history2006.jpg": 95657,
	"./museums/history/history2006_02.jpg": 59789,
	"./museums/history/history2006_03.png": 98729,
	"./museums/history/history2006_04.jpg": 85584,
	"./museums/history/history2008.jpg": 47597,
	"./museums/history/history2008_02.jpg": 38535,
	"./museums/history/history2010.jpg": 42459,
	"./museums/history/history2012.jpg": 94067,
	"./museums/history/history2015.jpg": 37769,
	"./museums/history/history2016.jpg": 40411,
	"./museums/history/history2017.jpg": 20351,
	"./museums/history/history2018.jpg": 63239,
	"./museums/history/history2019.jpg": 22138,
	"./museums/history/history2023.jpg": 92845,
	"./museums/history/hot_title01_sp.png": 76973,
	"./museums/history/hot_title02_sp.png": 65662,
	"./museums/history/hot_title03_sp.png": 47715,
	"./museums/history/hot_title1991.png": 35579,
	"./museums/history/hot_title1996.png": 66607,
	"./museums/history/hot_title2004.png": 26146,
	"./museums/history/hot_title2012.png": 76538,
	"./museums/history/hot_title2018.png": 88606,
	"./museums/history/hot_title2023.png": 67599,
	"./museums/history/ico_attention.png": 64515,
	"./museums/history/ico_ballon_blue.svg": 63029,
	"./museums/history/ico_ballon_green.svg": 16582,
	"./museums/history/ico_ballon_light_blue.svg": 66757,
	"./museums/history/ico_ballon_light_green.svg": 61284,
	"./museums/history/ico_ballon_orange.svg": 65674,
	"./museums/history/ico_ballon_purple.svg": 93781,
	"./museums/history/ico_ballon_red.svg": 9576,
	"./museums/history/ico_ballon_yellow.svg": 47016,
	"./museums/history/ico_featured.png": 53861,
	"./museums/history/ico_flag.png": 39415,
	"./museums/history/ico_flag_sp.png": 53365,
	"./museums/history/ico_igiari.png": 74676,
	"./museums/history/ico_pin_blue.svg": 94624,
	"./museums/history/ico_pin_green.svg": 3354,
	"./museums/history/ico_pin_purple.svg": 53848,
	"./museums/history/ico_pin_yellow.svg": 37613,
	"./museums/history/ico_start.png": 21409,
	"./museums/history/main.png": 54765,
	"./museums/history/ogp.png": 4489,
	"./museums/history/photo1984.jpg": 39450,
	"./museums/history/photo1990.jpg": 39913,
	"./museums/history/photo1991.jpg": 85826,
	"./museums/history/photo1992.jpg": 23080,
	"./museums/history/photo1993.jpg": 96237,
	"./museums/history/photo1997.jpg": 88391,
	"./museums/history/photo2000.jpg": 90254,
	"./museums/history/photo2001.jpg": 63852,
	"./museums/history/photo2002.jpg": 5003,
	"./museums/history/photo2009.jpg": 93994,
	"./museums/history/title.png": 76098,
	"./museums/history/title_sp.png": 5718,
	"./museums/history/txt_1984.svg": 5925,
	"./museums/history/txt_1985.svg": 3680,
	"./museums/history/txt_1987.svg": 5497,
	"./museums/history/txt_1989.svg": 98669,
	"./museums/history/txt_1990.svg": 95047,
	"./museums/history/txt_1991.svg": 47784,
	"./museums/history/txt_1992.svg": 19031,
	"./museums/history/txt_1993.svg": 46121,
	"./museums/history/txt_1994.svg": 57591,
	"./museums/history/txt_1996.svg": 42732,
	"./museums/history/txt_1997.svg": 89902,
	"./museums/history/txt_2000.svg": 81930,
	"./museums/history/txt_2001.svg": 46654,
	"./museums/history/txt_2002.svg": 5826,
	"./museums/history/txt_2004.svg": 62893,
	"./museums/history/txt_2005.svg": 85217,
	"./museums/history/txt_2006.svg": 31300,
	"./museums/history/txt_2008.svg": 56877,
	"./museums/history/txt_2009.svg": 64190,
	"./museums/history/txt_2010.svg": 67130,
	"./museums/history/txt_2011.svg": 60855,
	"./museums/history/txt_2012.svg": 263,
	"./museums/history/txt_2015.svg": 81561,
	"./museums/history/txt_2016.svg": 81323,
	"./museums/history/txt_2017.svg": 35470,
	"./museums/history/txt_2018.svg": 86611,
	"./museums/history/txt_2019.svg": 99199,
	"./museums/history/txt_2023.svg": 46356,
	"./museums/history/txt_history_of_capcom.png": 73783,
	"./museums/ico_movie.svg": 71849,
	"./museums/ico_music.svg": 48518,
	"./museums/ico_new.png": 44317,
	"./museums/ico_title_next.png": 20161,
	"./museums/ico_title_next_sp.png": 92704,
	"./museums/ico_title_prev.png": 2118,
	"./museums/ico_title_prev_sp.png": 24710,
	"./museums/megaman/guide.png": 31411,
	"./museums/monsterhunter/guide.png": 56340,
	"./museums/ogp.png": 70288,
	"./museums/residentevil/guide.png": 80508,
	"./museums/residentevil/portal_logo.jpg": 77938,
	"./museums/special/guide.png": 79160,
	"./museums/streetfighter/bnr_external.png": 59756,
	"./museums/streetfighter/guide.png": 8265,
	"./museums/txt_museum.svg": 73859,
	"./museums/txt_titles.svg": 42776,
	"./news/bg.jpg": 65342,
	"./news/bg_board.png": 84755,
	"./news/bg_paper_blue01.png": 33901,
	"./news/bg_paper_blue02.png": 68449,
	"./news/bg_paper_yellow01.png": 32222,
	"./news/bg_paper_yellow02.png": 74574,
	"./news/bg_shadow.png": 63301,
	"./news/bg_sp.jpg": 73001,
	"./news/bg_texture.png": 26944,
	"./news/bg_title_bottom.png": 3095,
	"./news/bg_title_side.png": 66577,
	"./news/bg_title_side_sp.png": 92908,
	"./news/img_tape_blue.png": 510,
	"./news/img_tape_orange.png": 32271,
	"./news/ogp.png": 93989,
	"./news/txt_title.svg": 35630,
	"./privacy_policy/txt_privacy_policy.svg": 41957,
	"./retro_games/bg.jpg": 5068,
	"./retro_games/bg_flame.png": 718,
	"./retro_games/bg_listnav_current.svg": 32006,
	"./retro_games/bg_sp.jpg": 15885,
	"./retro_games/controller-button_a.png": 26773,
	"./retro_games/controller-button_b.png": 34789,
	"./retro_games/controller-button_down.png": 42382,
	"./retro_games/controller-button_l.png": 48096,
	"./retro_games/controller-button_left.png": 89214,
	"./retro_games/controller-button_r.png": 3113,
	"./retro_games/controller-button_right.png": 77774,
	"./retro_games/controller-button_select.png": 28180,
	"./retro_games/controller-button_start.png": 89901,
	"./retro_games/controller-button_up.png": 85149,
	"./retro_games/controller-button_x.png": 74525,
	"./retro_games/controller-button_y.png": 71442,
	"./retro_games/controller_nes.png": 10170,
	"./retro_games/controller_snes.png": 2435,
	"./retro_games/emulator/btn_ab.svg": 87551,
	"./retro_games/emulator/btn_ab_shadow.svg": 24536,
	"./retro_games/emulator/btn_abxy.svg": 75778,
	"./retro_games/emulator/btn_abxy_shadow.svg": 43766,
	"./retro_games/emulator/btn_cross.svg": 40707,
	"./retro_games/emulator/btn_l.svg": 8168,
	"./retro_games/emulator/btn_r.svg": 20727,
	"./retro_games/emulator/btn_select.svg": 75474,
	"./retro_games/emulator/btn_start.svg": 63596,
	"./retro_games/emulator/img_device.png": 90202,
	"./retro_games/emulator/img_mettaur.png": 69714,
	"./retro_games/img_bubble.svg": 58988,
	"./retro_games/img_elections_prize.png": 197,
	"./retro_games/img_title_list01.png": 48962,
	"./retro_games/img_title_list02.png": 7842,
	"./retro_games/line_neon.svg": 97582,
	"./retro_games/nes_en/console.jpg": 14881,
	"./retro_games/nes_ja/console.jpg": 24182,
	"./retro_games/ogp.png": 48718,
	"./retro_games/snes_en/console.jpg": 1794,
	"./retro_games/snes_ja/console.jpg": 46234,
	"./retro_games/txt_capcoms_retro_games.svg": 12981,
	"./retro_games/txt_capcoms_retro_games_sp.svg": 59978,
	"./retro_games/txt_challengers.svg": 50788,
	"./retro_games/txt_controller_select.svg": 38072,
	"./retro_games/txt_controls.svg": 22709,
	"./retro_games/txt_manual.svg": 3836,
	"./retro_games/txt_scroll.svg": 14321,
	"./right/txt_rights_notation.svg": 14059,
	"./rooms/bg_bubble.svg": 3353,
	"./rooms/bg_character_bubble01.png": 34100,
	"./rooms/bg_character_bubble02.png": 44729,
	"./rooms/bg_end.jpg": 91450,
	"./rooms/bg_end_sp.jpg": 85018,
	"./rooms/bg_icon.png": 69962,
	"./rooms/bg_introduction.png": 13328,
	"./rooms/bg_introduction_sp.png": 71679,
	"./rooms/bg_start01.png": 69007,
	"./rooms/bg_start02.png": 27312,
	"./rooms/ceo/bg01.jpg": 77929,
	"./rooms/ceo/bg01_sp.jpg": 50861,
	"./rooms/ceo/bg02.jpg": 49811,
	"./rooms/ceo/bg02_sp.jpg": 43879,
	"./rooms/ceo/bg03.jpg": 5974,
	"./rooms/ceo/bg03_sp.jpg": 65750,
	"./rooms/ceo/bg04.jpg": 2593,
	"./rooms/ceo/bg04_sp.jpg": 89370,
	"./rooms/ceo/bg05.jpg": 5176,
	"./rooms/ceo/bg05_sp.jpg": 39170,
	"./rooms/ceo/bg06.jpg": 11551,
	"./rooms/ceo/bg06_sp.jpg": 59060,
	"./rooms/ceo/bg07.jpg": 65637,
	"./rooms/ceo/bg07_sp.jpg": 7629,
	"./rooms/ceo/bg_lets_go.png": 51132,
	"./rooms/ceo/ceo.png": 72284,
	"./rooms/ceo/famous_quote01.png": 72830,
	"./rooms/ceo/famous_quote02.png": 56138,
	"./rooms/ceo/famous_quote03.png": 66209,
	"./rooms/ceo/famous_quote04.png": 5675,
	"./rooms/ceo/famous_quote05.png": 7823,
	"./rooms/ceo/famous_quote06.png": 57730,
	"./rooms/ceo/famous_quote07.png": 80536,
	"./rooms/ceo/famous_quote08.png": 64302,
	"./rooms/ceo/famous_quote09.png": 7109,
	"./rooms/ceo/famous_quote10.png": 62902,
	"./rooms/ceo/famous_quote11.png": 88638,
	"./rooms/ceo/famous_quote12.png": 10590,
	"./rooms/ceo/famous_quote_ceo01.png": 83246,
	"./rooms/ceo/famous_quote_ceo02.png": 26730,
	"./rooms/ceo/famous_quote_ceo03.png": 88355,
	"./rooms/ceo/famous_quote_ceo04.png": 37488,
	"./rooms/ceo/famous_quote_stamp.png": 74934,
	"./rooms/ceo/hanging_scroll.png": 92790,
	"./rooms/ceo/history1983.jpg": 65128,
	"./rooms/ceo/history1988.jpg": 41088,
	"./rooms/ceo/history1994.jpg": 11145,
	"./rooms/ceo/history2000.jpg": 9551,
	"./rooms/ceo/history2016.jpg": 80169,
	"./rooms/ceo/history2023.jpg": 13088,
	"./rooms/ceo/ico_ceo.png": 62981,
	"./rooms/ceo/map1988.png": 14491,
	"./rooms/ceo/map1994.png": 12887,
	"./rooms/ceo/map2000.png": 716,
	"./rooms/ceo/map2016.png": 30086,
	"./rooms/ceo/ogp.png": 90909,
	"./rooms/ceo/road_start.png": 82702,
	"./rooms/ceo/txt_i_am_the_ceo.svg": 17535,
	"./rooms/ceo/txt_scroll.svg": 86003,
	"./rooms/ceo/txt_welcome_to_the_ceos_room.svg": 36887,
	"./rooms/character_ace-attorney .png": 72573,
	"./rooms/character_airou.png": 83070,
	"./rooms/character_chun-li.png": 72017,
	"./rooms/character_date-masamune.png": 2310,
	"./rooms/character_honda.png": 73276,
	"./rooms/character_jill.png": 74675,
	"./rooms/character_licker.png": 99362,
	"./rooms/character_mettaur.png": 50052,
	"./rooms/character_monster-hunter.png": 71109,
	"./rooms/character_morrigan.png": 2645,
	"./rooms/character_naruhodo.png": 9604,
	"./rooms/character_nemesis.png": 15676,
	"./rooms/character_red-arremer.png": 2622,
	"./rooms/character_ryu.png": 65015,
	"./rooms/coo/bg01.jpg": 57862,
	"./rooms/coo/bg01_sp.jpg": 23681,
	"./rooms/coo/bg02.jpg": 32896,
	"./rooms/coo/bg02_sp.jpg": 94535,
	"./rooms/coo/bg03.jpg": 73568,
	"./rooms/coo/bg03_sp.jpg": 58570,
	"./rooms/coo/bg04.jpg": 82077,
	"./rooms/coo/bg04_sp.jpg": 74621,
	"./rooms/coo/bg05.jpg": 96665,
	"./rooms/coo/bg05_sp.jpg": 86249,
	"./rooms/coo/bg06.jpg": 28433,
	"./rooms/coo/bg06_sp.jpg": 43382,
	"./rooms/coo/bg07.jpg": 31602,
	"./rooms/coo/bg07_sp.jpg": 87088,
	"./rooms/coo/bg_here_we_go.png": 18915,
	"./rooms/coo/coo.png": 29050,
	"./rooms/coo/history1983.jpg": 71807,
	"./rooms/coo/history1992.jpg": 30752,
	"./rooms/coo/history1999.jpg": 90808,
	"./rooms/coo/history2007.jpg": 29199,
	"./rooms/coo/history2013.jpg": 20079,
	"./rooms/coo/history2023.jpg": 47199,
	"./rooms/coo/ico_coo.png": 74240,
	"./rooms/coo/map1992.png": 36678,
	"./rooms/coo/map1999.png": 5318,
	"./rooms/coo/map2007.png": 75728,
	"./rooms/coo/map2013.png": 39510,
	"./rooms/coo/map2023.png": 14956,
	"./rooms/coo/ogp.png": 37560,
	"./rooms/coo/txt_i_am_the_coo.svg": 46815,
	"./rooms/coo/txt_welcome_to_the_coos_room.svg": 52947,
	"./rooms/ico_number01.png": 94930,
	"./rooms/ico_number02.png": 42019,
	"./rooms/ico_number03.png": 55339,
	"./rooms/ico_number04.png": 7001,
	"./rooms/ico_number05.png": 31878,
	"./rooms/ico_number06.png": 46277,
	"./rooms/ico_scroll_arrow.svg": 93268,
	"./rooms/ico_sparkle01.svg": 23908,
	"./rooms/ico_sparkle02.svg": 71795,
	"./rooms/ico_sparkle03.svg": 87254,
	"./rooms/ico_sparkle04.svg": 65532,
	"./rooms/ico_sparkle05.svg": 14533,
	"./rooms/line.png": 31711,
	"./rooms/map1983.png": 51071,
	"./rooms/map_line01.svg": 64052,
	"./rooms/map_line01_sp.svg": 14831,
	"./rooms/map_line02.svg": 67412,
	"./rooms/map_line02_sp.svg": 32221,
	"./rooms/map_line03.svg": 87355,
	"./rooms/map_line03_sp.svg": 82843,
	"./rooms/map_line04.svg": 67460,
	"./rooms/map_line04_sp.svg": 39652,
	"./rooms/map_line05.svg": 40425,
	"./rooms/map_line05_sp.svg": 86296,
	"./rooms/map_line06.svg": 35545,
	"./rooms/map_line06_sp.svg": 48494,
	"./rooms/navigation01.png": 82414,
	"./rooms/navigation02.png": 48581,
	"./rooms/navigation03.png": 59011,
	"./rooms/navigation04.png": 57806,
	"./rooms/navigation05.png": 10809,
	"./rooms/navigation06.png": 44807,
	"./rooms/object_bell.png": 12215,
	"./rooms/object_board.png": 11304,
	"./rooms/object_building.png": 68438,
	"./rooms/object_clapperboard.png": 31276,
	"./rooms/object_cotton-candy.png": 22051,
	"./rooms/object_cracker.png": 18558,
	"./rooms/object_excavator.png": 22448,
	"./rooms/object_globe.png": 81605,
	"./rooms/object_hammer.png": 95822,
	"./rooms/object_stone01.png": 75448,
	"./rooms/object_stone02.png": 80804,
	"./rooms/object_stone03.png": 29359,
	"./rooms/object_town-building.png": 15065,
	"./rooms/object_tree01.png": 31820,
	"./rooms/object_tree02.png": 13939,
	"./rooms/road01.png": 650,
	"./rooms/road01_sp.png": 82068,
	"./rooms/road02.png": 89583,
	"./rooms/road02_sp.png": 71305,
	"./rooms/road03.png": 25351,
	"./rooms/road03_sp.png": 16842,
	"./rooms/road04.png": 53080,
	"./rooms/road04_sp.png": 48399,
	"./rooms/road05.png": 79753,
	"./rooms/road05_sp.png": 95108,
	"./rooms/road06.png": 85484,
	"./rooms/road06_sp.png": 60848,
	"./rooms/road_end.png": 32316,
	"./rooms/road_start.png": 51109,
	"./rooms/txt_page_top.svg": 79321,
	"./rooms/txt_scroll.svg": 20511,
	"./super_elections/v1/bg_bubble.png": 34769,
	"./super_elections/v1/img_truck.png": 58986,
	"./super_elections/v1/logo_de.png": 44648,
	"./super_elections/v1/logo_en.png": 55223,
	"./super_elections/v1/logo_es.png": 97224,
	"./super_elections/v1/logo_fr.png": 70101,
	"./super_elections/v1/logo_it.png": 6729,
	"./super_elections/v1/logo_ja.png": 71251,
	"./super_elections/v1/logo_ko.png": 61531,
	"./super_elections/v1/logo_only_title_de.png": 19322,
	"./super_elections/v1/logo_only_title_en.png": 59229,
	"./super_elections/v1/logo_only_title_es.png": 65135,
	"./super_elections/v1/logo_only_title_fr.png": 61496,
	"./super_elections/v1/logo_only_title_it.png": 55565,
	"./super_elections/v1/logo_only_title_ja.png": 87871,
	"./super_elections/v1/logo_only_title_ko.png": 35500,
	"./super_elections/v1/logo_only_title_pt-BR.png": 31073,
	"./super_elections/v1/logo_only_title_zh-CN.png": 31409,
	"./super_elections/v1/logo_only_title_zh-TW.png": 86671,
	"./super_elections/v1/logo_pt-BR.png": 54791,
	"./super_elections/v1/logo_zh-CN.png": 81230,
	"./super_elections/v1/logo_zh-TW.png": 13826,
	"./super_elections/v1/questions/bg_balloon.png": 11564,
	"./super_elections/v1/questions/bg_balloon_sp.png": 53056,
	"./super_elections/v1/questions/bg_complete.jpg": 64299,
	"./super_elections/v1/questions/bg_complete_sp.jpg": 87131,
	"./super_elections/v1/questions/bg_confirm.jpg": 41959,
	"./super_elections/v1/questions/bg_confirm_sp.jpg": 96343,
	"./super_elections/v1/questions/bg_floor.png": 92554,
	"./super_elections/v1/questions/bg_floor_sp.png": 81486,
	"./super_elections/v1/questions/bg_form.png": 46991,
	"./super_elections/v1/questions/bg_form_sp.png": 47718,
	"./super_elections/v1/questions/bg_introduction.png": 28474,
	"./super_elections/v1/questions/bg_introduction02.jpg": 71587,
	"./super_elections/v1/questions/bg_introduction02_sp.jpg": 67999,
	"./super_elections/v1/questions/bg_introduction03.jpg": 44517,
	"./super_elections/v1/questions/bg_introduction03_sp.jpg": 76981,
	"./super_elections/v1/questions/bg_introduction04.jpg": 22640,
	"./super_elections/v1/questions/bg_introduction04_sp.jpg": 67234,
	"./super_elections/v1/questions/bg_introduction05.jpg": 19876,
	"./super_elections/v1/questions/bg_introduction05_sp.jpg": 74590,
	"./super_elections/v1/questions/bg_introduction_sp.png": 47209,
	"./super_elections/v1/questions/bg_question.jpg": 43631,
	"./super_elections/v1/questions/bg_question02.jpg": 57796,
	"./super_elections/v1/questions/bg_question02_sp.jpg": 47728,
	"./super_elections/v1/questions/bg_question03.jpg": 51985,
	"./super_elections/v1/questions/bg_question03_sp.jpg": 16828,
	"./super_elections/v1/questions/bg_question04.jpg": 90076,
	"./super_elections/v1/questions/bg_question04_sp.jpg": 74930,
	"./super_elections/v1/questions/bg_question05.jpg": 90955,
	"./super_elections/v1/questions/bg_question05_sp.jpg": 78340,
	"./super_elections/v1/questions/bg_question06.jpg": 71207,
	"./super_elections/v1/questions/bg_question06_sp.jpg": 8440,
	"./super_elections/v1/questions/bg_question07.jpg": 77792,
	"./super_elections/v1/questions/bg_question07_sp.jpg": 77439,
	"./super_elections/v1/questions/bg_question08.jpg": 30913,
	"./super_elections/v1/questions/bg_question08_sp.jpg": 84489,
	"./super_elections/v1/questions/bg_question09.jpg": 39439,
	"./super_elections/v1/questions/bg_question09_sp.jpg": 68329,
	"./super_elections/v1/questions/bg_question10.jpg": 22086,
	"./super_elections/v1/questions/bg_question10_sp.jpg": 61068,
	"./super_elections/v1/questions/bg_question11.jpg": 12980,
	"./super_elections/v1/questions/bg_question11_sp.jpg": 81321,
	"./super_elections/v1/questions/bg_question_sp.jpg": 66049,
	"./super_elections/v1/questions/bg_search.svg": 35903,
	"./super_elections/v1/questions/bg_title.png": 72352,
	"./super_elections/v1/questions/bnr_museum.png": 65460,
	"./super_elections/v1/questions/bnr_retro.png": 88394,
	"./super_elections/v1/questions/ico_checkbox_off.png": 91598,
	"./super_elections/v1/questions/ico_checkbox_on.png": 56965,
	"./super_elections/v1/questions/ico_nav01.png": 27782,
	"./super_elections/v1/questions/ico_nav01_current.png": 61330,
	"./super_elections/v1/questions/ico_nav02.png": 29792,
	"./super_elections/v1/questions/ico_nav02_current.png": 52488,
	"./super_elections/v1/questions/ico_nav03.png": 30871,
	"./super_elections/v1/questions/ico_nav03_current.png": 2300,
	"./super_elections/v1/questions/ico_nav04.png": 43828,
	"./super_elections/v1/questions/ico_nav04_current.png": 55783,
	"./super_elections/v1/questions/ico_nav05.png": 56791,
	"./super_elections/v1/questions/ico_nav05_current.png": 11763,
	"./super_elections/v1/questions/ico_nav06.png": 20887,
	"./super_elections/v1/questions/ico_nav06_current.png": 33216,
	"./super_elections/v1/questions/ico_nav07.png": 5818,
	"./super_elections/v1/questions/ico_nav07_current.png": 35502,
	"./super_elections/v1/questions/ico_nav08.png": 84724,
	"./super_elections/v1/questions/ico_nav08_current.png": 56988,
	"./super_elections/v1/questions/ico_nav09.png": 64202,
	"./super_elections/v1/questions/ico_nav09_current.png": 65620,
	"./super_elections/v1/questions/ico_nav10.png": 58687,
	"./super_elections/v1/questions/ico_nav10_current.png": 77147,
	"./super_elections/v1/questions/ico_nav_arrow.png": 36974,
	"./super_elections/v1/questions/ico_nav_arrow02.png": 76883,
	"./super_elections/v1/questions/ico_nav_goal.png": 54465,
	"./super_elections/v1/questions/ico_nav_goal_current.png": 21203,
	"./super_elections/v1/questions/ico_question01.png": 63471,
	"./super_elections/v1/questions/ico_question02.png": 96311,
	"./super_elections/v1/questions/ico_question03.png": 61680,
	"./super_elections/v1/questions/ico_question04.png": 84754,
	"./super_elections/v1/questions/ico_question05.png": 80626,
	"./super_elections/v1/questions/ico_question06.png": 99046,
	"./super_elections/v1/questions/ico_question07.png": 67247,
	"./super_elections/v1/questions/ico_question08.png": 41161,
	"./super_elections/v1/questions/ico_question09.png": 3349,
	"./super_elections/v1/questions/ico_question10.png": 81153,
	"./super_elections/v1/questions/ico_radio_off.png": 82654,
	"./super_elections/v1/questions/ico_radio_on.png": 12722,
	"./super_elections/v1/questions/img_character.png": 62350,
	"./super_elections/v1/questions/img_character_sp.png": 41734,
	"./super_elections/v1/questions/img_complete.png": 85856,
	"./super_elections/v1/questions/img_complete_sp.png": 31750,
	"./super_elections/v1/questions/img_select.png": 4086,
	"./super_elections/v1/questions/img_truck.png": 23675,
	"./super_elections/v1/questions/q12/decline.jpg": 4428,
	"./super_elections/v1/questions/q12/hanafuda.jpg": 24726,
	"./super_elections/v1/questions/q12/illustrated_book.jpg": 87524,
	"./super_elections/v1/questions/q12/pin_badge.jpg": 97546,
	"./super_elections/v1/questions/q5/1942.png": 77798,
	"./super_elections/v1/questions/q5/ace_attorney.png": 72309,
	"./super_elections/v1/questions/q5/breath_of_fire.png": 9438,
	"./super_elections/v1/questions/q5/darkstalkers.png": 16285,
	"./super_elections/v1/questions/q5/dead_rising.png": 42085,
	"./super_elections/v1/questions/q5/devil_may_cry.png": 11685,
	"./super_elections/v1/questions/q5/dino_crisis.png": 20313,
	"./super_elections/v1/questions/q5/dragons_dogma.png": 97237,
	"./super_elections/v1/questions/q5/final_fight.png": 86857,
	"./super_elections/v1/questions/q5/ghostsn_goblins.png": 62820,
	"./super_elections/v1/questions/q5/lost_planet.png": 6141,
	"./super_elections/v1/questions/q5/mega_man.png": 52692,
	"./super_elections/v1/questions/q5/monster_hunter.png": 87794,
	"./super_elections/v1/questions/q5/okami.png": 99028,
	"./super_elections/v1/questions/q5/onimusha.png": 61113,
	"./super_elections/v1/questions/q5/resident_evil.png": 75019,
	"./super_elections/v1/questions/q5/sengoku_basara.png": 7534,
	"./super_elections/v1/questions/q5/street_fighter.png": 60883,
	"./super_elections/v1/questions/q5/toraware_no_paruma.png": 44391,
	"./super_elections/v1/questions/q5/vs_capcom.png": 9851,
	"./super_elections/v1/questions/q6/ace_attorney.png": 76316,
	"./super_elections/v1/questions/q6/breath_of_fire.png": 70394,
	"./super_elections/v1/questions/q6/commando.png": 38256,
	"./super_elections/v1/questions/q6/final_fight.png": 6599,
	"./super_elections/v1/questions/q6/gargoyles_quest.png": 83337,
	"./super_elections/v1/questions/q6/mega_man.png": 1797,
	"./super_elections/v1/questions/q6/nijiirocho_no_kiseki.png": 29332,
	"./super_elections/v1/questions/q6/not_in_here.png": 63656,
	"./super_elections/v1/questions/q6/onimusya.png": 21820,
	"./super_elections/v1/questions/q6/rival_schools.png": 87704,
	"./super_elections/v1/questions/txt_answer_this_question.svg": 38165,
	"./super_elections/v1/questions/txt_thank_you.svg": 67629,
	"./super_elections/v1/super_elections_001_ogp_de.png": 76125,
	"./super_elections/v1/super_elections_001_ogp_en.png": 17839,
	"./super_elections/v1/super_elections_001_ogp_es.png": 16363,
	"./super_elections/v1/super_elections_001_ogp_fr.png": 57918,
	"./super_elections/v1/super_elections_001_ogp_it.png": 74328,
	"./super_elections/v1/super_elections_001_ogp_ja.png": 76752,
	"./super_elections/v1/super_elections_001_ogp_ko.png": 94379,
	"./super_elections/v1/super_elections_001_ogp_pt-BR.png": 43248,
	"./super_elections/v1/super_elections_001_ogp_zh-CN.png": 97899,
	"./super_elections/v1/super_elections_001_ogp_zh-TW.png": 40204,
	"./super_elections/v1/tickets/attorney.png": 51043,
	"./super_elections/v1/tickets/bg_balloon_left.png": 23143,
	"./super_elections/v1/tickets/bg_balloon_left_sp.png": 86328,
	"./super_elections/v1/tickets/bg_balloon_right.png": 21554,
	"./super_elections/v1/tickets/bg_balloon_right_sp.png": 54892,
	"./super_elections/v1/tickets/bg_card.png": 27211,
	"./super_elections/v1/tickets/bg_form.png": 7180,
	"./super_elections/v1/tickets/bg_ribbon.png": 64986,
	"./super_elections/v1/tickets/bg_road.png": 3374,
	"./super_elections/v1/tickets/bg_road_sp.png": 54093,
	"./super_elections/v1/tickets/bg_ticket.png": 45025,
	"./super_elections/v1/tickets/bg_ticket02.png": 60370,
	"./super_elections/v1/tickets/bg_ticket02_sp.png": 49063,
	"./super_elections/v1/tickets/character_airou.png": 68027,
	"./super_elections/v1/tickets/character_arthur.png": 94683,
	"./super_elections/v1/tickets/character_chun-li.png": 91150,
	"./super_elections/v1/tickets/character_dante.png": 4926,
	"./super_elections/v1/tickets/character_date-masamune.png": 61744,
	"./super_elections/v1/tickets/character_haggar.png": 32120,
	"./super_elections/v1/tickets/character_jill.png": 38545,
	"./super_elections/v1/tickets/character_leilei.png": 7621,
	"./super_elections/v1/tickets/character_mayoi.png": 4445,
	"./super_elections/v1/tickets/character_naruhodo.png": 56447,
	"./super_elections/v1/tickets/character_rockman.png": 51232,
	"./super_elections/v1/tickets/character_v.png": 55822,
	"./super_elections/v1/tickets/cleaner.png": 33317,
	"./super_elections/v1/tickets/double_jump.png": 24255,
	"./super_elections/v1/tickets/fighter.png": 10942,
	"./super_elections/v1/tickets/hadoken.png": 82440,
	"./super_elections/v1/tickets/headshot.png": 90873,
	"./super_elections/v1/tickets/high_time.png": 27516,
	"./super_elections/v1/tickets/hunter.png": 11892,
	"./super_elections/v1/tickets/ico_radio_select.svg": 91070,
	"./super_elections/v1/tickets/img_mettaur.png": 12840,
	"./super_elections/v1/tickets/img_ticket.png": 2237,
	"./super_elections/v1/tickets/img_ticket_making.png": 84712,
	"./super_elections/v1/tickets/img_ticket_sp.png": 6032,
	"./super_elections/v1/tickets/knight.png": 21438,
	"./super_elections/v1/tickets/objection.png": 62742,
	"./super_elections/v1/tickets/police.png": 91540,
	"./super_elections/v1/tickets/robot.png": 3890,
	"./super_elections/v1/tickets/sliding.png": 81148,
	"./super_elections/v1/tickets/spirit_blade.png": 31626,
	"./super_elections/v1/tickets/truck.png": 80220,
	"./term/txt_terms_of_service.svg": 69681,
	"./top/landing/bg_landing_pc.svg": 80787,
	"./top/landing/bg_landing_sp.svg": 18419,
	"./top/landing/ico_mute_black.svg": 67219,
	"./top/landing/ico_mute_white.svg": 60016,
	"./top/landing/ico_sound_black.svg": 70442,
	"./top/landing/ico_sound_white.svg": 99175,
	"./top/landing/img_castle_01.svg": 5581,
	"./top/landing/img_castle_02.svg": 40815,
	"./top/landing/img_cloud_01.svg": 13410,
	"./top/landing/img_cloud_02.svg": 99893,
	"./top/landing/img_kobun.svg": 9153,
	"./top/landing/img_rathalos_01.svg": 33455,
	"./top/landing/img_rathalos_02.svg": 52734,
	"./top/landing/img_sonson.svg": 75217,
	"./top/landing/img_truck.svg": 24683,
	"./top/landing/img_truck_02.svg": 59186,
	"./top/landing/img_vega.svg": 33188,
	"./top/landing/logo_40th.png": 33595,
	"./top/landing/logo_capcom_town.png": 15612,
	"./top/landing/text_off_black.svg": 53815,
	"./top/landing/text_off_white.svg": 10385,
	"./top/landing/text_on_black.svg": 20719,
	"./top/landing/text_on_white.svg": 38792,
	"./top/ogp.png": 95925,
	"./top/opening/bg_map_blur.jpg": 86803,
	"./top/opening/bg_sky_pc.png": 49717,
	"./top/opening/bg_sky_sp.png": 58125,
	"./top/opening/img_airou.png": 55013,
	"./top/opening/img_all_characters.png": 40718,
	"./top/opening/img_all_characters@2x.png": 25084,
	"./top/opening/img_balloon_pc.png": 52150,
	"./top/opening/img_balloon_sp.png": 31499,
	"./top/opening/img_bar_text_pc.svg": 17590,
	"./top/opening/img_bar_text_sp.svg": 99532,
	"./top/opening/img_building.png": 45740,
	"./top/opening/img_cloud_01.png": 25585,
	"./top/opening/img_cloud_02.png": 45768,
	"./top/opening/img_cloud_03.png": 9261,
	"./top/opening/img_cloud_04.png": 70356,
	"./top/opening/img_cloud_05.png": 83744,
	"./top/opening/img_cloud_06.png": 45204,
	"./top/opening/img_makaimura.png": 54945,
	"./top/opening/img_plane.png": 90052,
	"./top/opening/img_pop_effect.svg": 46624,
	"./top/opening/img_rathalos.png": 13417,
	"./top/opening/img_sonson.png": 13232,
	"./top/opening/img_vega.png": 68044,
	"./top/opening/text_thanks_pc.svg": 93706,
	"./top/opening/text_thanks_sp.svg": 96804,
	"./top/top_modal/img_character_04_01.png": 86506,
	"./top/top_modal/img_character_04_01_sp.png": 92585,
	"./top/top_modal/img_character_04_02.png": 48728,
	"./top/top_modal/img_character_04_02_sp.png": 57585,
	"./top/top_modal/img_character_pin_elections.png": 30852,
	"./top/top_modal/img_character_pin_museum.png": 74106,
	"./top/top_modal/img_character_tab1_01.png": 36387,
	"./top/top_modal/img_character_tab1_02.png": 25000,
	"./top/top_modal/img_character_tab2_01.png": 83897,
	"./top/top_modal/img_character_tab2_02.png": 11660,
	"./top/top_modal/img_character_tab3_01.png": 90918,
	"./top/top_modal/img_character_tab3_02.png": 48460,
	"./top/top_modal/img_introduction_01_pc.jpg": 59246,
	"./top/top_modal/img_introduction_01_pc_de.jpg": 10680,
	"./top/top_modal/img_introduction_01_pc_en.jpg": 96932,
	"./top/top_modal/img_introduction_01_pc_es.jpg": 54538,
	"./top/top_modal/img_introduction_01_pc_fr.jpg": 13014,
	"./top/top_modal/img_introduction_01_pc_it.jpg": 23545,
	"./top/top_modal/img_introduction_01_pc_ja.jpg": 90692,
	"./top/top_modal/img_introduction_01_pc_ko.jpg": 32210,
	"./top/top_modal/img_introduction_01_pc_pt-BR.jpg": 40353,
	"./top/top_modal/img_introduction_01_pc_zh-CN.jpg": 24989,
	"./top/top_modal/img_introduction_01_pc_zh-TW.jpg": 85764,
	"./top/top_modal/img_introduction_01_sp.jpg": 36635,
	"./top/top_modal/img_introduction_01_sp_de.jpg": 30156,
	"./top/top_modal/img_introduction_01_sp_en.jpg": 97396,
	"./top/top_modal/img_introduction_01_sp_es.jpg": 99853,
	"./top/top_modal/img_introduction_01_sp_fr.jpg": 90595,
	"./top/top_modal/img_introduction_01_sp_it.jpg": 89254,
	"./top/top_modal/img_introduction_01_sp_ja.jpg": 66362,
	"./top/top_modal/img_introduction_01_sp_ko.jpg": 11509,
	"./top/top_modal/img_introduction_01_sp_pt-BR.jpg": 12032,
	"./top/top_modal/img_introduction_01_sp_zh-CN.jpg": 4277,
	"./top/top_modal/img_introduction_01_sp_zh-TW.jpg": 73608,
	"./top/top_modal/img_introduction_02_pc.jpg": 49823,
	"./top/top_modal/img_introduction_02_sp.jpg": 64586,
	"./top/top_modal/img_introduction_03_pc.jpg": 70141,
	"./top/top_modal/img_introduction_03_sp.jpg": 99440,
	"./top/top_modal/img_introduction_04_pc.jpg": 46817,
	"./top/top_modal/img_introduction_04_pc_de.jpg": 69901,
	"./top/top_modal/img_introduction_04_pc_en.jpg": 29904,
	"./top/top_modal/img_introduction_04_pc_es.jpg": 36358,
	"./top/top_modal/img_introduction_04_pc_fr.jpg": 90946,
	"./top/top_modal/img_introduction_04_pc_it.jpg": 65313,
	"./top/top_modal/img_introduction_04_pc_ja.jpg": 25213,
	"./top/top_modal/img_introduction_04_pc_ko.jpg": 6611,
	"./top/top_modal/img_introduction_04_pc_pt-BR.jpg": 61806,
	"./top/top_modal/img_introduction_04_pc_zh-CN.jpg": 42924,
	"./top/top_modal/img_introduction_04_pc_zh-TW.jpg": 85890,
	"./top/top_modal/img_introduction_04_sp.jpg": 87234,
	"./top/top_modal/img_introduction_04_sp_de.jpg": 44109,
	"./top/top_modal/img_introduction_04_sp_en.jpg": 69350,
	"./top/top_modal/img_introduction_04_sp_es.jpg": 29580,
	"./top/top_modal/img_introduction_04_sp_fr.jpg": 21019,
	"./top/top_modal/img_introduction_04_sp_it.jpg": 79530,
	"./top/top_modal/img_introduction_04_sp_ja.jpg": 57094,
	"./top/top_modal/img_introduction_04_sp_ko.jpg": 63583,
	"./top/top_modal/img_introduction_04_sp_pt-BR.jpg": 35269,
	"./top/top_modal/img_introduction_04_sp_zh-CN.jpg": 41571,
	"./top/top_modal/img_introduction_04_sp_zh-TW.jpg": 64340,
	"./top/top_modal/img_num_1.svg": 62472,
	"./top/top_modal/img_num_2.svg": 88408,
	"./top/top_modal/img_num_3.svg": 87172,
	"./top/top_modal/title_elections.svg": 52814,
	"./top/top_modal/title_modal.svg": 80001,
	"./top/top_modal/title_museum.svg": 58730
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41898;